import { render, staticRenderFns } from "./TaskTags.vue?vue&type=template&id=7ef517d3&scoped=true&"
import script from "./TaskTags.vue?vue&type=script&lang=js&"
export * from "./TaskTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef517d3",
  null
  
)

export default component.exports